import firebase from 'firebase/app';

import 'firebase/auth';
import 'firebase/database';

const config = {
  apiKey: "AIzaSyDDwU3houeFmFvd1kKAXzHhekC085w4EPM",
  authDomain: "kiwi-app-staging.firebaseapp.com",
  databaseURL: "https://kiwi-app-staging.firebaseio.com",
  storageBucket: "",
};

firebase.initializeApp(config);

export class Auth {
  /**
   * Listens for a user being logged in or out
   * - callback returns a user object
   * - function returns a disposable reference
   **/
  onAuthStateChanged(cb) {
    return firebase.auth().onAuthStateChanged(cb);
  }

  /**
   * Signs out
   *
   * - returns a promise
   */
  signOut() {
    return firebase.auth().signOut();
  }

  /**
   * Signs in
   * - returns a promise
   */
  signIn() {
    const provider = new firebase.auth.GoogleAuthProvider();
    return firebase.auth().signInWithPopup(provider);
  }
}

export class Db {
  ref(ref) {
    return firebase.database().ref(ref);
  }

  createId(type) {
    return this.ref().child(type).push().key;
  }

  update(updates) {
    return this.ref().update(updates);
  }
}


/** WEBPACK FOOTER **
 ** ./src/adapters/firebase.js
 **/